<template>
  <span>
    <base-button
      :icon="isIcon"
      size="sm"
      :disabled="isReadOnly"
      data-backdrop="static"
      data-keyboard=false
      data-toggle="modal"
      data-target="disbursingCollectionInformationModal"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info white'"
      @click.native="viewItem"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <modal
      v-on:close="closeForm"
      :show.sync="showModal"
      modal-id="disbursingCollectionInformationModal"
      headerClasses="justify-content-center"
    >
      <h4 slot="header" class="title title-up">{{modalTitle}}</h4>
      <hr />
      <div class="container">
        <label style="padding-top: 10px;">Fund Citation</label>
        <v-select
          :disabled="isReadOnly || !isNew"
          v-model="disbursingCollection.fundCitationId"
          name="fundCitationId"
          :error="getError('fundCitationId')"
          label="name"
          v-validate="'required'"
          data-vv-as="Accepting Nation / Organization"
          :class="errors.has('fundCitationId') ? 'has-danger' : ''"
          :reduce="(fundCitation) => fundCitation.fundCitationId"
          :options="fundCitations"
          placeholder="Select one"
        >
          <template slot="option" slot-scope="option">
            {{ `${option.name} - (${option.abbreviation})` }}
          </template>
        </v-select>
        <span v-show="errors.has('fundCitationId')" class="error">Fund Citation is required</span>
        <br />
        <div v-if="isUsBuyOrder">
          <label style="padding-top: 10px;">Amount Paid</label>
        <base-input
            :disabled="isReadOnly"
            type="text"
            name="amountCollected"
            v-model="disbursingCollection.amountPaid"
            v-on:blur="currencyFormatter"
          @focus="backToInput" 
            data-vv-as="Amount Paid"
          @keypress="filterNumber($event)"

            v-validate="'required'"
          ></base-input>
        <span v-show="errors.has('amountPaid')" class="error"
          > {{ errors.first("amountPaid") }}
        </span>
        </div>
        <div v-if="!isUsBuyOrder">
          <label style="padding-top: 10px;">Amount Collected</label>
          <base-input
            :disabled="isReadOnly"
            type="text"
            name="amountCollected"
            v-model="disbursingCollection.amountPaid"
            v-on:blur="currencyFormatter"
          @focus="backToInput" 
            data-vv-as="Amount Collected"
            @keypress="filterNumber($event)"
            v-validate="'required'"
          ></base-input>
          <span v-show="errors.has('amountCollected')" class="error">
            {{ errors.first("amountCollected") }}
          </span>
        </div>
        <br />
        <div v-if="isUsBuyOrder">
          <label style="padding-top: 10px;">Tracer No</label>
          <base-input
            :disabled="isReadOnly"
            type="text"
            name="tracer"
            data-vv-as="Tracer Number"
            v-model="disbursingCollection.tracer"
            v-validate="'required'"
          ></base-input>
          <span v-show="errors.has('tracer')" class="error">
            {{ errors.first("tracer") }}
          </span>
        </div>
        <div v-if="!isUsBuyOrder">
          <label style="padding-top: 10px;">Voucher No</label>
          <base-input
            :disabled="isReadOnly"
            type="text"
            name="voucher"
            data-vv-as="Voucher Number"
            v-model="disbursingCollection.voucher"
            v-validate="'required'"
          ></base-input>
          <span v-show="errors.has('voucher')" class="error">
            {{ errors.first("voucher") }}
          </span>
        </div>
        <br />
        <div v-if="isUsBuyOrder">
          <label style="padding-top: 10px;">Tracer Date</label>
          <el-date-picker
            :disabled="isReadOnly"
            type="date"
            format="dd-MMMM-yyyy"
            placeholder="Tracer Date"
            v-validate="'required'"
            name="tracerDate"
            data-vv-as="Tracer Date"
            v-model="disbursingCollection.tracerDate"
          >
          </el-date-picker>
          <span v-show="errors.has('tracerDate')" class="error">
            {{ errors.first("tracerDate") }}
          </span>
        </div>
        <div v-if="!isUsBuyOrder">
          <label style="padding-top: 10px;">Voucher Date</label>
          <el-date-picker
            :disabled="isReadOnly"
            type="date"
            format="dd-MMMM-yyyy"
            placeholder="Voucher Date"
            v-validate="'required'"
            name="voucherDate"
            data-vv-as="Voucher Date"
            v-model="disbursingCollection.voucherDate"
          >
          </el-date-picker>
          <span v-show="errors.has('voucherDate')" class="error">
            {{ errors.first("voucherDate") }}
          </span>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="closeForm"
          >
            Close
          </base-button>
          <base-button
            :disabled="isReadOnly"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submit"
          >
            {{ isNew ? "Save" : "Update" }}
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from "@/util/util";

export default {
  name: "disbursing-collection-information-modal",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    showDisbursingCollectionInformationModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      priceInput: null 
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  watch: {
    "disbursingCollection.fundCitationId": function (newVal, oldVal) {
      if (this.fundCitations && this.showModal) {
        const fundCitation = this.fundCitations.filter(
          (fundCitation) => fundCitation.fundCitationId === newVal
        );
        this.disbursingCollection.abbreviation = fundCitation[0].abbreviation;
      }
    },
  },
  computed: {
    ...mapGetters({
      orderMetadata: "orderMetadata/orderMetadata",
      fundCitations: "fundCitation/fundCitations",
      disbursingCollection:
        "disbursingCollectionInformation/disbursingCollection",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
    }),
    showModal() {
      return (
        this.showDisbursingCollectionInformationModal || this.modals.classic
      );
    },
    modalTitle () {
      return this.isUsBuyOrder ? 'Add Disbursement' : 'Add Collection';
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
  },
  mounted() {
    this.errors.clear();
  },
  methods: {
    ...mapActions({
      getDisbursingCollectionById:
        "disbursingCollectionInformation/getDisbursingCollectionById",
      saveDisbursingCollection:
        "disbursingCollectionInformation/saveDisbursingCollection",
      updateDisbursementCollection:
        "disbursingCollectionInformation/updateDisbursementCollection",
      loadAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/loadAllDisbursingInfoByOrderId",
      clearDisbursingCollection:
        "disbursingCollectionInformation/clearDisbursingCollection",
    }),
    currencyFormatter(event) {
      this.priceInput = (event.target.value)
      let test = new Intl.NumberFormat('en-US', { 
        currency: 'USD', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 10 }).format(event.target.value);
      this.disbursingCollection.amountPaid = test.toString();
    },
    backToInput(event){
      this.disbursingCollection.amountPaid =  this.priceInput
    },
    filterNumber(evt) {
      // only allow number
      // to prevent extra chars, use event.keyCode === <charCode> || <repeat>
        evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    closeForm() {
      this.loadAllDisbursingInfoByOrderId(this.getOrderIdFromRoute);
      this.clearDisbursingCollection();
      this.modals.classic = false;
      this.errors.clear();
      this.$emit("modal-closed");
    },
    showLineItemErrors(response) {
      if (this.lineItemErrors.length > 0) {
        this.lineItemErrors.forEach((error) => this.$toast.error(error));
      }
    },
    async submit(e) {
      if(this.disbursingCollection.fundCitationId === 0 || this.disbursingCollection.fundCitationId === '') {
        this.$toast.error("Fund Citation is required!!");
        return;
      }
      let ctx = this;
      this.$validator.validateAll().then(async(result) => {
        if(result) {
        let response = await ctx.saveDisbursingCollection(
          ctx.getOrderIdFromRoute
        );
        ctx.errors.clear();
        ctx.modals.classic = false;
        ctx.$emit("modal-closed");
        ctx.loadAllDisbursingInfoByOrderId(ctx.getOrderIdFromRoute);
        ctx.clearDisbursingCollection();
        } else {
          this.$toast.error("Please fill the form required fields.");
        }
      })
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
    viewItem() {
        if (this.isNew) {
            // Reset the v-model and other fields
            this.disbursingCollection.fundCitationId = undefined;
            this.disbursingCollection.amountPaid = null;
            this.priceInput = null;
            this.modals.classic = true;
        }
    this.errors.clear();
    },
  },
};
</script>

<style>
.has-danger .vs__dropdown-toggle {
  border-color: hsl(6, 90%, 49%) !important;
}

.error {
  color: #ec250d;
  font-size: 0.75rem;
}
</style>
